import { LocationOnOutlined } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import NumericWidget from '@/features/dashboard/components/NumericWidget'
import { NumericWidgetSkeleton } from '@/features/dashboard/components/NumericWidgetSkeleton'
import { useSitesQuery } from '@/features/site/hooks/useSitesQuery'
import { SiteStatus } from '@/features/site/types/site'

function SiteCountWidget() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { sites, isLoading } = useSitesQuery()

  if (isLoading) {
    return <NumericWidgetSkeleton />
  }

  return (
    <NumericWidget
      icon={<LocationOnOutlined color="secondary" fontSize="large" />}
      title={t('component.navbar.customers')}
      value={sites?.filter((site) => site.status === SiteStatus.ENABLED).length ?? 0}
      onClick={() => navigate(`/sites`)}
    />
  )
}

export default SiteCountWidget
